import { getBackOfficeEntityDataSource } from '@@modules/admin/api';
import { getCommunityAPIProxy } from './index';
import { defaultPostHeaderForJsonData } from '@inwink/apibase';
import { getCustomerAPIProxy } from '@@customer/api';

export function getCommunityPreviewId(communityId: string): Promise<any> {
    const proxy = getCommunityAPIProxy();
    return proxy.getJson(`${communityId}/previewid`);
}

export function getCommunityDetail(communityId: string): Promise<any> {
    const proxy = getCommunityAPIProxy();
    return getParentNames(communityId).then((result) => {
        return Promise.all([
            proxy.getJson(`communityinfo/${communityId}`),
            proxy.getJson(`${communityId}/communitydetail/${communityId}`).then((res) => {
                res.id = res.communityId;
                return res;
            }),
            getBackOfficeEntityDataSource<any>('', 'me/communities', '', {
                query: {
                    selects: {
                        computedUrl: true,
                    },
                    filters: {
                        id: {
                            $Equal: communityId
                        },
                    }
                },
            }).query(),
            getCustomerAPIProxy().getJson(`${result.customerId}/audience/${result.tenantId}/AuthTenantCommunity/${communityId}`)
                .then((res) => res, () => null)
        ]).then((results) => {
            const computedUrl = results[2]?.data?.[0]?.computedUrl as any;
            return Object.assign({}, results[0], results[1], results[3], {computedUrl: computedUrl}, {
                parentNames: result
            });
        });
    }); 
}

function getParentNames(communityId: string): Promise<ICommunityParentNames> {
    return getCommunityAPIProxy().getJson(`${communityId}/parents-details`).then((res) => res, () => null);
}

export interface ICommunityParentNames {
    tenantId: string;
    tenantName: string;
    customerId: string;
    customerName: string;
}

export function updateCommunity(communityId: string, tenantId: string, customerId: string, conf: any) {
    const communityPayload = { entity: { ...conf, id: communityId }};
    
    return getCustomerAPIProxy()
        .postJson(`${customerId}/audience/${tenantId}/c/${communityId}/authtenantcommunityconfig/${communityId}`,
            JSON.stringify(communityPayload), defaultPostHeaderForJsonData);
}

export function getAvailableLanguages(communityId: string) : Promise<{ supportedLanguages: string[] }> {
    return getCommunityAPIProxy().getJson(`${communityId}/available-languages`);
}

export function setNotificationsConfiguration(eventId: string, fragment: string, conf) {
    return getCommunityAPIProxy().postJson(`configfragment/${eventId}/notificationsconfiguration/${fragment}`,
        JSON.stringify(conf), defaultPostHeaderForJsonData);
}
